(function () {
    const main = document.querySelector("main");
    const sections = [
        ...document.querySelectorAll(
            ".landing-hero, .landing-showcase, .landing-collection"
        )
    ];
    const collectionItems = document.querySelector(".landing-collection__items");
    let current = 0;
    let isAnimating = false;
    let touchStartY = 0;
    let releaseTimer = null;
    const TRANSITION_MS = 800;
    const COOLDOWN_MS = TRANSITION_MS + 100;
    const WHEEL_THRESHOLD = 300;
    const WHEEL_IDLE_RESET_MS = 300;
    let wheelAccum = 0;
    let lastWheelTime = 0;
    function render() {
        sections.forEach((section, index) => {
            section.style.zIndex = index + 1;
            section.style.transform =
                index <= current
                    ? "translateY(0)"
                    : "translateY(100%)";
        });
    }
    function goToIndex(index) {
        if (isAnimating) return;
        if (index < 0 || index >= sections.length) return;
        if (index === current) return;
        current = index;
        isAnimating = true;
        render();
        clearTimeout(releaseTimer);
        releaseTimer = setTimeout(() => {
            isAnimating = false;
        }, COOLDOWN_MS);
    }
    function isScrollAtEdge(el, direction) {
        const atTop = el.scrollTop <= 0;
        const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight;
        if (direction > 0) return atBottom;
        if (direction < 0) return atTop;
        return true;
    }
    main.addEventListener("wheel", function (e) {
        const listEl = e.target.closest(".landing-collection__items");
        if (listEl) {
            const needsInnerScroll = listEl.scrollHeight > listEl.clientHeight;
            if (needsInnerScroll && !isScrollAtEdge(listEl, e.deltaY)) {
                wheelAccum = 0;
                return;
            }
        }
        e.preventDefault();
        if (isAnimating) return;
        const now = Date.now();
        if (now - lastWheelTime > WHEEL_IDLE_RESET_MS) {
            wheelAccum = 0;
        }
        lastWheelTime = now;
        wheelAccum += e.deltaY;
        if (Math.abs(wheelAccum) >= WHEEL_THRESHOLD) {
            const direction = wheelAccum > 0 ? 1 : -1;
            wheelAccum = 0;
            goToIndex(current + direction);
        }
    }, {
        passive: false
    });
    main.addEventListener("touchstart", function (e) {
        touchStartY = e.touches[0].clientY;
    }, {
        passive: true
    });
    main.addEventListener("touchmove", function (e) {
        const listEl = e.target.closest(".landing-collection__items");
        if (listEl) {
            const needsInnerScroll = listEl.scrollHeight > listEl.clientHeight;
            if (needsInnerScroll) {
                return;
            }
        }
        e.preventDefault();
    }, {
        passive: false
    });
    main.addEventListener("touchend", function (e) {
        const listEl = e.target.closest(".landing-collection__items");
        if (isAnimating) return;
        const touchEndY = e.changedTouches[0].clientY;
        const diff = touchStartY - touchEndY;
        if (Math.abs(diff) < 30) return;
        if (listEl) {
            const needsInnerScroll = listEl.scrollHeight > listEl.clientHeight;
            const direction = diff > 0 ? 1 : -1;
            if (needsInnerScroll && !isScrollAtEdge(listEl, direction)) {
                return;
            }
        }
        if (diff > 0) {
            goToIndex(current + 1);
        } else {
            goToIndex(current - 1);
        }
    });
    window.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || e.key === "PageDown") {
            goToIndex(current + 1);
        }
        if (e.key === "ArrowUp" || e.key === "PageUp") {
            goToIndex(current - 1);
        }
    });
    $('.landing-hero__btn-url, .landing-showcase__left-btn .landing-showcase__btn-url').click(function(e){
    e.preventDefault();
    // var target = $(this).attr('href');
    // $(target).parent().css('transform', 'translateY(0)');
    goToIndex(4);
    })

    render();
})();







$(".mobile-cart , .cart-button").on("click", function () {
    $("body").addClass("cart-show");
});
$(".overlay").on("click", function () {
    $("body").removeClass("cart-show");
});

$(document).on('click', '.cart-drawer__close', function(){
$("body").removeClass("cart-show");
})



